<template>
  <div class="container">
  
    <leftBar
      @logout="logoutAction"
      @leaveState="clickLeave"
      :isLeaved="leaved"
    ></leftBar>

    <div class="left1" v-if="isLeft">
        
        <JwChat-talk class="rightSlot" @sendQuick="sendQuickAction" />
      </div>
      <div class="left" v-else>
        
        <client-list :quick="quickStr" @changeQuick="changeQuickStr"></client-list>
      </div>

      <div class="resize" title="收缩侧边栏">
        ⋮
      </div>
      <div class="right1" v-if="isLeft">
        <client-list :quick="quickStr" @changeQuick="changeQuickStr" style="padding-left: 0px;"></client-list>
      </div>
      <div class="right" v-else>
        <JwChat-talk class="rightSlot" @sendQuick="sendQuickAction" />
      </div>
  
    <!-- <div class="screenfull_btn" @click="screenfullToggle" @mouseenter="seenterScreenFull" @mouseleave="leaveScreenFull"> -->
    <!-- <el-button type="infor" @click="screenfullToggle" size="mini">{{screenBtn}}</el-button> -->
    <!-- 			<img v-show="screenBtn=='全屏'&&seenter==true" :src="screenFullSrc1" style="width: 1.25rem;height: 1.25rem;margin-top: 1.1875rem;"/>
			<img v-show="screenBtn=='全屏'&&seenter==false" :src="screenFullSrc2" style="width: 1.25rem;height: 1.25rem;margin-top: 1.1875rem;"/>
			<img v-show="screenBtn=='最大化'&&seenter==true" :src="screenFullSrc3" style="width: 1.25rem;height: 1.25rem;margin-top: 1.1875rem;"/>
			<img v-show="screenBtn=='最大化'&&seenter==false" :src="screenFullSrc4" style="width: 1.25rem;height: 1.25rem;margin-top: 1.1875rem;"/>
			<span :class="seenter==true?'screenfull_btn_text1':'screenfull_btn_text2'">{{screenBtn}}</span> -->
    <!-- </div> -->
    <!-- <screenFullBtn></screenFullBtn> -->

    <transter
      v-if="isDialog"
      :showDialog="isDialog"
      @closeTranster="cancelTranster"
      :serviceList="customList"
      @setCustomer="setLeave"
      type="1"
    ></transter>
    <!-- <div class="version_div">
			<span>{{time}}</span>
			<span>{{version}}</span> 
		</div> -->
  </div>
</template>

<script>
import screenfull from "screenfull";
import leftBar from "../components/leftBar.vue";
import clientList from "../components/clientList.vue";
import {
  connectWebsocket2,
  closeWebsocket,
  // wsState
} from "@/utils/websocket.js";
import transter from "../components/Chat/transter.vue";
import { MessageBox } from "element-ui";
// import config from "../utils/electronConfig.js";
// import config from '../utils/electronConfig.js'
// import screenFullBtn from "../components/screenFullBtn.vue"

export default {
  components: {
    leftBar,
    clientList,
    transter,
    // screenFullBtn
  },

  data() {
    return {
      isDialog: false,
      isLeft: false,
      customList: [],
      leaved: false,
      quickStr: "",
      isReConnect: false,
      isShowNav: true,
      fromTag: 0, //0-其它界面 1-从设置界面返回的
      time: "",
      version: "",
      screenBtn: "最大化",
      screenFull: true,
      screenFullSrc1: require("../../static/talks/icon_fullscreen1.png"),
      screenFullSrc2: require("../../static/talks/icon_fullscreen2.png"),
      screenFullSrc3: require("../../static/talks/icon_fullscreen3.png"),
      screenFullSrc4: require("../../static/talks/icon_fullscreen4.png"),
      seenter: false,
    };
  },

  created() {
    console.log("Home created tip = ", this.util.getLoginTip());
    connectWebsocket2();
    window.addEventListener("resize", this.onresize);
    window.addEventListener("keydown", this.keydown);

    this.getConfigList();
  },

  mounted() {

    this.dragControllerDiv();
    
    const userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.indexOf("electron/") != -1) {
      const fs = this.$nodeFs;
      var options = {
        siteObj: JSON.parse(localStorage.getItem("siteObj")),
        username: JSON.parse(localStorage.getItem("username")),
        station: this.util.getLocalSite().webId,
        stations: JSON.parse(localStorage.getItem("stations")),
        stationsAndNames: JSON.parse(localStorage.getItem("stationsAndNames")),
        inputHeight: JSON.parse(localStorage.getItem("inputHeight")),
      };
      try {
        fs.writeFileSync(this.userDirectory, JSON.stringify(options));
      } catch (error) {
        console.log("Home.vue mounted 文件写入 失败原因", error);
      }

      // fs.writeFile(
      //   // this.util.electronCache,
      //   this.userDirectory,
      //   JSON.stringify(options),
      //   function (err) {
      //     console.log(
      //       "Home.vue 写入文件 mounted options:",
      //       JSON.stringify(options)
      //     );
      //     if (err) {
      //       console.log("Home.vue 写入文件 失败" + err);
      //       return;
      //     }
      //     console.log("Home.vue 写入文件 It's saved!");
      //   }
      // );
    }
    // ipc.send("news");
    // this.getConfigRequest()
    this.getAllConfRequest();


    if (this.fromTag === 1) {
      this.$store.state.selectedClient = null;
      return;
    }

    this.version = localStorage.getItem("version");
    this.time = this.util.getFormatDate(0);
    this.time = "2021/03/22 15:23";
    console.log("当前日期", this.time);
  },

  beforeDestroy() {
    // 页面销毁时关闭ws。因为有可能ws连接接收数据尚未完成，用户就跳转了页面
    // 在需要主动关闭ws的地方都可以调用该方法
    // closeWebsocket()
    window.removeEventListener("resize", this.onresize);
    window.removeEventListener("keydown", this.keydown);
  },

  destroyed() {
    //销毁监听
    //this.socket.onclose = this.close
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      var pathStr = from.path;
      if (pathStr.search("setting") === -1) {
        vm.fromTag = 0;
      } else {
        vm.fromTag = 1;
      }
    });

    next();
  },

  //监听当前页面返回事件
  beforeRouteLeave(to, from, next) {
    //next方法传true或者不传为默认历史返回，传false为不执行历史回退
    if (to.name === "login") {
      this.$confirm("确定退出吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.logoutRequest();
        })
        .catch(() => {
          next(false);
        });
    } else {
      next(true);
    }
  },

  methods: {
    // connectSccess(data) {
    // 	console.log('Home connectSccess data = ', data)
    // 	const jsonData = JSON.parse(data.data)
    // 	if (jsonData.type === '1') {
    // 		if (this.isReConnect === true) {
    // 			this.$message({
    // 				message: '重新创建链接成功！',
    // 				type: 'success'
    // 			});
    // 		}
    // 	}
    // },

    dragControllerDiv () {
      var resize = document.getElementsByClassName('resize');
      var left = document.getElementsByClassName('left');
      if(this.isLeft){
        left = document.getElementsByClassName('left1');
      }
      var mid = document.getElementsByClassName('right');
      if(this.isLeft){
        mid = document.getElementsByClassName('right1');
      }
      var box = document.getElementsByClassName('container');
      var isTempLeft = this.isLeft;
      for (let i = 0; i < resize.length; i++) {
          // 鼠标按下事件
          resize[i].onmousedown = function (e) {
            console.log('onmousedown ==');
              //颜色改变提醒
              resize[i].style.background = '#818181';
              var startX = e.clientX;
              resize[i].left = resize[i].offsetLeft;
              // 鼠标拖动事件
              document.onmousemove = function (e) {
                  var endX = e.clientX;
                  var moveLen = resize[i].left + (endX - startX); // （endx-startx）=移动的距离。resize[i].left+移动的距离=左边区域最后的宽度
                  var maxT = box[i].clientWidth - resize[i].offsetWidth; // 容器宽度 - 左边区域的宽度 = 右边区域的宽度
                  if(isTempLeft){
                    if (moveLen < 300) moveLen = 300; // 左边区域的最小宽度为300px
                    if (moveLen > maxT - 800) moveLen = maxT - 800; //右边区域最小宽度为800px
                  }else{
                    if (moveLen < 500) moveLen = 500; // 左边区域的最小宽度为500px
                    if (moveLen > maxT - 300) moveLen = maxT - 300; //右边区域最小宽度为300px
                  }
                  resize[i].style.left = moveLen; // 设置左侧区域的宽度
                  for (let j = 0; j < left.length; j++) {
                    left[j].style.width = moveLen + 'px';
                    mid[j].style.width = (box[i].clientWidth - moveLen - 10) + 'px';
                  }
            
              };
              // 鼠标松开事件
              document.onmouseup = function (evt) {
                  //颜色恢复
                  console.log(evt)
                  resize[i].style.background = '#d6d6d6';
                  document.onmousemove = null;
                  document.onmouseup = null;
                  resize[i].releaseCapture && resize[i].releaseCapture(); //当你不在需要继续获得鼠标消息就要应该调用ReleaseCapture()释放掉
              };
              resize[i].setCapture && resize[i].setCapture(); //该函数在属于当前线程的指定窗口里设置鼠标捕获
              return false;
          };
      }
  },




    screenfullToggle() {
      screenfull.toggle();
    },
    // 阻止F11默认事件
    keydown(event) {
      if (event.keyCode === 122) {
        event.preventDefault();
        event.returnValue = false;
      }
    },
    // 判断是否全屏
    onresize() {
      let winFlag = window.innerHeight == window.screen.height;
      let isFull = window.fullScreen || document.webkitIsFullScreen;
      if (isFull === undefined) {
        this.screenFull = winFlag;
      } else {
        this.screenFull = winFlag || isFull;
      }
      if (this.screenFull == false) {
        this.screenBtn = "全屏";
      } else {
        this.screenBtn = "最大化";
      }
      console.log("isScreenFull winFlag || isFull", winFlag, isFull);
    },
    // 鼠标悬浮事件
    seenterScreenFull() {
      this.seenter = true;
    },

    leaveScreenFull() {
      this.seenter = false;
    },
    // connectError(data) {
    // 	console.log('Home connectError data = ', data)

    // 	if (data === undefined) {
    // 		console.log('Home connectError isLogout = ', this.$store.state.authority.isInLogout)
    // 		if (this.$store.state.authority.isInLogout === true) {
    // 			this.$router.push("/")

    // 		} else {
    // 			this.$confirm('聊天链接已断开, 是否重新创立连接?', '提示', {
    // 				confirmButtonText: '确定',
    // 				cancelButtonText: '取消',
    // 				type: 'warning',
    // 				showClose: false,
    // 			}).then(() => {
    // 				this.isReConnect = true
    // 				connectWebsocket1(this.connectSccess, this.connectError)

    // 			}).catch(() => {
    // 				this.$message({
    // 					type: 'info',
    // 					message: '已取消创立连接'
    // 				});
    // 			});
    // 		}

    // 	}
    // },

    logoutAction() {
      console.log("home logoutAction");
      const tipMsg = "是否确认退出";
      MessageBox.alert(tipMsg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        showCancelButton: true,
      }).then(() => {
        // let hrefList = this.$store.state.hrefData;

        // // this.$store.state.hrefData[hrefIndex].closed == true

        // for (let item in hrefList) {
        //   if (hrefList[item].closed != true) {
        //     hrefList[item].close();
        //   }
        // }
        // 关闭其他所有窗口
        if (this.$nodeFs) {
          const ipc = this.$electron.ipcRenderer;
          ipc.send("closeAllWindow");
        }
        this.logoutRequest();
      });
    },

    logoutPop(str) {
      this.$confirm(str, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: null,
        type: "warning",
        showClose: false,
        showCancelButton: false,
      })
        .then(() => {
          this.logoutAction();
        })
        .catch(() => {});
    },

    async logoutRequest() {
      var api = "/manager/user/logOut";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
      });
      console.log("home logoutRequest response = ", response);
      // this.$store.state.hrefData = {};
      // config.setHrefData(this.$store.state.hrefData);
      closeWebsocket();

      if (response.resultCode === "10000") {
        console.log("home logoutRequest 000");

        this.$store.state.selectedClient = null;

        this.util.pauseFlickerAudio();

        this.util.setWsState("0");

        this.util.setLoginTip(0);
        // 退出登录，重载页面，刷新vuex
        location.reload("/");

        // clearInterval(this.util.heartTimer)
        // this.util.wsReconCount = 0

        // setTimeout(() => {
        // 	this.$router.push("/")
        // }, 500);
      } else {
        this.$message.error(response.desc);
      }
    },

    async getConfigList() {
      const api = "/manager/sysconf/listSystemParams";
      const res = await this.util.postRequest({
        url: api,
        method: "GET",
      });
      console.log("ConfigParams.vue getConfigList res = ", res);
      if (res.resultCode !== "10000") {
        this.$message.error(res.desc);
      } else {
        this.configList = res.data ? res.data : [];
        for (let i = 0; i < this.configList.length; i++) {
          const item = this.configList[i];

          switch (item.confKey) {
            case "MESSAGE_REMINDER_COLOR": {
              this.$store.state.newMsgColor = item.confVal;
              break;
            }
            default:
              () => {};
          }
        }
      }
    },

    clickLeave(istate) {
      console.log("Home clickLeave state = ", istate);
      this.leaved = false;
      this.getOnLineUser();
    },

    async getOnLineUser() {
      // var api = "/manager/chat/online/cs/list";
      var api = "/manager/chat/colleague/online/cs/list";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
      });
      console.log("Home getOnLineUser response = ", response);
      if (response.data.length === 0) {
        this.$confirm("没有在线客服可供选择，暂无法转接离开！", "提示", {
          confirmButtonText: "确定",
          showClose: false,
          showCancelButton: false,
          type: "warning",
        });

        return;
      } else {
        this.isDialog = true;
        this.customList = [];
        let dataList = response.data;
        for (var i = 0; i < dataList.length; i++) {
          var custom = dataList[i];
          custom.selected = false;
          //1-在线 2-忙碌 0-离开
          if (custom.status === 1) {
            custom.state = "在线";
          } else if (custom.status === 2) {
            custom.state = "忙碌";
          } else if (custom.status === 0) {
            custom.state = "离开";
          }

          this.customList.push(custom);
        }
      }
    },

    cancelTranster(obj) {
      console.log("Home cancelTranster obj = ", obj);
      this.isDialog = obj;
    },

    async setLeave(isShow, obj) {
      console.log("Home setLeave obj = ", obj);
      this.isDialog = isShow;

      var api = "/manager/chat/cs/leave";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          t_csid: obj.csid,
        },
      });

      const selected = this.$store.state.selectedClient;
      console.log("Home setLeave response = ", response);
      console.log("Home setLeave selected = ", selected);
      if (response.resultCode === "10000") {
        this.leaved = true;
        this.$store.state.selectedClient = null;
        console.log("Home setLeave selected00 = ", selected);
      } else {
        this.$message.error(response.desc);
      }

      this.isDialog = false;
    },

    sendQuickAction(str) {
      console.log("Home sendQuickAction str = ", str);
      this.quickStr = str;
      this.$store.state.newQuickFlag = true;
    },
    changeQuickStr(data) {
      console.log("Home changeQuickStr str = ", this.str);
      this.quickStr = data;
    },
    async getAllConfRequest() {
      console.log("msgCodeBox getAllConfRequest");
      var api = "/manager/settingConfig/selectConfigList";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
      });
      console.log("msgCodeBox getAllConfRequest response = ", response);
      if (response.resultCode === "10000") {
        console.log("msgCodeBox getAllConfRequest data = ", response.data);
        const paraList = response.data;
        for (var i = 0; i < paraList.length; i++) {
          const parameter = paraList[i];
          if (parameter.id === "7") {
            const listjson = parameter.jsonParam;
            const list = JSON.parse(listjson);
            for (var j = 0; j < list.length; j++) {
              var obj = list[j];
              if (obj.isSelect) {
                this.util.setLocalFlickerUrl(this.util.nullToString(obj.value));
                this.$store.state.flickerAudioUrl = this.util.nullToString(
                  obj.value
                );
                let audio = document.getElementById("audio");
                audio.src = this.util.nullToString(obj.value);
                console.log("audio.src=======", audio.src);
              }
            }
          } else if (parameter.id === "5") {
            const listjson = parameter.jsonParam;
            const list = JSON.parse(listjson);

            for (var k = 0; k < list.length; k++) {
              var item = list[k];
              if (item.isSelect) {
                this.$store.state.maxLeaveNum = item.value;
                // if (item.value === '1') {
                // 	this.$store.state.maxLeaveNum = 30
                // } else if (item.value === '2') {
                // 	this.$store.state.maxLeaveNum = 50
                // } else {
                // 	this.$store.state.maxLeaveNum = 0
                // }
              }
            }
          } else if (parameter.id === "12") {
            const list = parameter.jsonParamList;

            for (var m = 0; m < list.length; m++) {
              var objtheme = list[m];
              if (objtheme.isSelect) {
                localStorage.setItem("nowtheme", objtheme.value);
              }
            }
          } else if (parameter.name === "音量设置") {
            const volumeList = parameter.jsonParamList;
            for (const item of volumeList) {
              if (item.isSelect === true) {
                this.volume = item.label;
                const audioList = document.querySelectorAll("audio");
                let volume = "";
                if (this.volume === "静音") {
                  volume = 0;
                } else if (this.volume === "小") {
                  volume = 0.25;
                } else if (this.volume === "正常") {
                  volume = 0.5;
                } else if (this.volume === "大") {
                  volume = 0.75;
                } else if (this.volume === "特大") {
                  volume = 1;
                }
                localStorage.setItem("volume", volume);
                for (const _item of audioList) {
                  _item.volume = volume;
                }
                break;
              }
            }
          }else if (parameter.name === "转潜提示音") {
            const listjson = parameter.jsonParam;
            const list = JSON.parse(listjson);
            for (var l = 0; l < list.length; l++) {
              var object = list[l];
              if ( object.isSelect) {
                console.log("this.util.nullToString(obj.value)" + this.util.nullToString(obj.value))
                this.util.setLocalZhuanqianUrl(this.util.nullToString(obj.value));
                this.$store.state.zhuanQianAudioUrl = this.util.nullToString(
                  object.value
                );
              }
            } 
            //this.util.playGetAudio();
          }else if (parameter.name === "进度提示音") {
            const listjson = parameter.jsonParam;
            const list = JSON.parse(listjson);
            for (var m1 = 0; m1 < list.length; m1++) {
              var object1 = list[m1];
              if (object1.isSelect) {
                console.log("this.util.nullToString(object1.value)" + this.util.nullToString(object1.value))
                this.util.setLocalProgressUrl(this.util.nullToString(object1.value));
                this.$store.state.progressAudioUrl = this.util.nullToString(
                  object1.value
                );
              }
            }
          }
          else if (parameter.name == "按会话展示") {
            const volumeList = parameter.jsonParamList;
            if (volumeList[0].value === "1") {
              this.$store.state.isShowSession = true;
            }else{
              this.$store.state.isShowSession = false;
            }
          }else if (parameter.name === "快捷回复位置设置") {
            const positionList = parameter.jsonParamList;
            for (const item of positionList) {
              if (item.isSelect === true) {
                var position = item.label;
                if(position == '左侧'){
                  this.isLeft = true;
                }
                break;
              }
            }
            this.dragControllerDiv();
          }
          //  else if (parameter.id === "16") {
          //   const item = parameter.jsonParamList[0];
          //   localStorage.setItem("quickPreviewSwitch", item.isSelect);
          // }
        }
      } else {
        this.$message.error(response.desc);
      }
    },

    // async getConfigRequest() {
    // 	console.log('Home getConfigRequest')
    // 	var api = "/manager/parameterSetting/queryThisUserVoice"
    // 	const response = await this.util.postRequest({
    // 		url: api,
    // 		method: "POST",
    // 		data: {

    // 		},
    // 	});
    // 	console.log("@@@@@@@@@@@@!!!!!!!!!index audioUrl response = ", response)
    // 	if (response.resultCode === '10000') {
    // 		const dataList = response.data
    // 		if (dataList.length === 0) {
    // 			const url1 = 'http://medibot.cc/images/upload/music1.mp3'
    // 			this.util.setLocalFlickerUrl(url1)
    // 			this.$store.state.flickerAudioUrl = url1

    // 			const url2 = 'http://medibot.cc/images/upload/music2.mp3'
    // 			this.util.setLocalNewUrl(url2)
    // 			this.$store.state.newAudioUrl = url2
    // 		} else {
    // 			for (var i = 0; i < dataList.length; i++) {
    // 				const obj = dataList[i]
    // 				if (obj.conf_name === '新消息提示') {
    // 					this.util.setLocalFlickerUrl(this.util.nullToString(obj.file_url))
    // 					this.$store.state.flickerAudioUrl = this.util.nullToString(obj.file_url)
    // 				} else if (obj.conf_name === '新用户提示') {
    // 					this.util.setLocalNewUrl(this.util.nullToString(obj.file_url))
    // 					this.$store.state.newAudioUrl = this.util.nullToString(obj.file_url)
    // 				}
    // 			}
    // 		}

    // 	} else {
    // 		this.$message.error(response.desc)
    // 	}
    // },
  },
};
</script>
<style scoped="scoped">

/*包围div样式*/
.box {
        width: 100%;
        height: 100vh;
    }
    /*左侧div样式*/
    .left {
        width: calc(80% - 10px);  /*左侧初始化宽度*/   
        height: 100vh;
        background-color: #5a9cf8;
    }

    /*左侧div样式*/
    .left1 {
        width: calc(20% - 10px);  /*左侧初始化宽度*/   
        height: 100vh;
        padding-left: 85px;
    }

  /*拖拽区div样式*/
  .resize {
      cursor: col-resize;
      float: left;
      position: relative;
      top: 45%;
      background-color: #d6d6d6;
      border-radius: 5px;
      margin-top: -10px;
      width: 10px;
      height: 50px;
      background-size: cover;
      background-position: center;
      /*z-index: 99999;*/
      font-size: 32px;
      color: white;
  }
  /*拖拽区鼠标悬停样式*/
  .resize:hover {
      color: #444444;
  }

.container {
  width: 100%;
  height: 100vh;
  background: #ffffff;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
}

/*右侧div'样式*/
.right {
    float: left;
    width: 20%;   /*右侧初始化宽度*/
    height: 100vh;
}

.right1 {
    float: left;
    width: 80%;   /*右侧初始化宽度*/
    height: 100vh;
    background-color: #5a9cf8;
    padding-left:0px;
}


.line_div {
  width: 0.25rem;
  height: 100vh;
  background: #e2e8f0;
  z-index: 1;
}

.rightSlot {
  width: 100%;
  height: 100vh;
  overflow: scroll;
  flex-direction: column;
}

.rightSlot::-webkit-scrollbar {
  display: none;
}

.right_div_home {
  width: 20%;
  height: 100vh;
  min-width: 180px;
  /* max-width: 400px;  */
  /* border-radius: 0 1.25rem 1.25rem 0; */
}

.version_div {
  width: 6%;
  height: 6.25rem;
  font-size: 0.75rem;
  background-color: red;
  z-index: 100;
  position: absolute;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  color: rgba(255, 255, 255, 0.4);
}

.screenfull_btn {
  width: 2.25rem;
  background: #f4f7fb;
  border-radius: 0px 24px 2px 0px;
  z-index: 100;
  position: absolute;
  top: 12%;
  /* right: 8.1%; */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.screenfull_btn_text1 {
  font-size: 0.75rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #5a9cf8;
  line-height: 0.9375rem;
  writing-mode: tb-rl;
  margin-top: 0.25rem;
  margin-bottom: 0.75rem;
}

.screenfull_btn_text2 {
  font-size: 0.75rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #a0abba;
  line-height: 0.9375rem;
  writing-mode: tb-rl;
  margin-top: 0.25rem;
  margin-bottom: 0.75rem;
}
</style>
